import { render, staticRenderFns } from "./PainAssessmentInpatient.vue?vue&type=template&id=3716ad10&scoped=true"
import script from "./PainAssessmentInpatient.vue?vue&type=script&lang=js"
export * from "./PainAssessmentInpatient.vue?vue&type=script&lang=js"
import style0 from "./PainAssessmentInpatient.vue?vue&type=style&index=0&id=3716ad10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3716ad10",
  null
  
)

export default component.exports